__turbopack_context__.v({
  "divider": "mochi-divider-module-scss-module__fjpFAq__divider",
});
